import './header-menu-core.js';

const BG_MENU_CLOSE_DELAY = 450;
const bgMenuCloseTimers = new WeakMap();
const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

function clearBgMenuCloseTimer(menu) {
  const timer = bgMenuCloseTimers.get(menu);
  if (timer) {
    clearTimeout(timer);
    bgMenuCloseTimers.delete(menu);
  }
}

document.addEventListener(
  'pointerenter',
  (event) => {
    if (!finePointer.matches || !(event.target instanceof Element)) return;
    const item = event.target.closest('header-menu .menu-list__list-item');
    if (!item || event.target !== item) return;
    const menu = item.closest('header-menu');
    if (menu) clearBgMenuCloseTimer(menu);
  },
  true
);

document.addEventListener(
  'pointerleave',
  (event) => {
    if (!finePointer.matches || !(event.target instanceof Element)) return;
    const item = event.target.closest('header-menu .menu-list__list-item');
    if (!item || event.target !== item) return;

    const menu = item.closest('header-menu');
    if (!menu || typeof menu.deactivate !== 'function') return;

    // Prevent the theme's immediate close. We close after a short hover-intent delay instead.
    event.stopImmediatePropagation();
    clearBgMenuCloseTimer(menu);

    const timer = setTimeout(() => {
      if (item.matches(':hover')) return;
      const submenu = item.querySelector(':scope > .menu-list__submenu');
      if (submenu?.matches(':hover')) return;
      menu.deactivate(event);
      bgMenuCloseTimers.delete(menu);
    }, BG_MENU_CLOSE_DELAY);

    bgMenuCloseTimers.set(menu, timer);
  },
  true
);
